// Object.values
var objectToValuesPolyfill = function (object) {
	return Object.keys(object).map(function (key) {
		return object[key]
	})
}
Object.values = Object.values || objectToValuesPolyfill
// Object.entries
var objectToEntriesPolyfill = function (object) {
	return Object.keys(object).map(function (key) {
		return [key, object[key]]
	})
}
Object.entries = Object.entries || objectToEntriesPolyfill

import '@babel/polyfill'
import 'core-js/es7/array';
import Vue from 'vue'
import store from './vueX/store'
import AppMenu from './AppMenu.vue'
import App from './App.vue'
import VueRouter from 'vue-router'
// import VuexPersistence from 'vuex-persist'
import routes from './routes'
import mixin from './mixin.js'

import VueI18n from 'vue-i18n'
import messages from './lang'
import VueScrollTo from 'vue-scrollto'


if (!Array.prototype.flat) {
    Array.prototype.flat = Array.prototype.flatten;
}

//import moment from 'moment-timezone'
//moment.tz.setDefault('Europe/Berlin')

Vue.config.productionTip = false

Vue.use(VueRouter, VueScrollTo)

const router = new VueRouter({
	mode: 'history',
	routes: routes,
	scrollBehavior() {
		return { x: 0, y: 0 }
	}
})

Vue.use(VueScrollTo, {
	container: "body",
	duration: 500,
	easing: "ease",
	offset: 0,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true
})

// Router gard... setting meta data
router.beforeEach((to, from, next) => {
	document.title = to.meta.title || 'Kläppen'
	document
		.querySelector('meta[name="description"]')
		.setAttribute('content', to.meta.description)

	if (to.name == 'accommodation') {
		try {
			const titleFromURL = to.params.id.split('_')[0].replace(/-/g, ' ')
			document.title = titleFromURL + ' - Kläppen Ski Resort' || 'Kläppen'
		} catch (error) {
			window.console.error(error)
		}
	}

	next()
})

// const vuexLocal = new VuexPersistence({
// 	storage: window.localStorage,
// })

Vue.use(VueI18n)
export const i18n = new VueI18n({
	locale: document.documentElement.lang,
	fallbackLocale: document.documentElement.lang,
	messages
})

// Custom directives
let handleOutsideClick

Vue.directive('click-outside', {
	bind(el, binding, vnode) {
		handleOutsideClick = e => {
			e.stopPropagation()
			const { handler, exclude } = binding.value

			let clickedOnExcludedEl = false
			exclude.forEach(refName => {
				if (!clickedOnExcludedEl) {
					const excludedEl = vnode.context.$refs[refName]
					if (excludedEl !== undefined) {
						clickedOnExcludedEl = excludedEl.contains(e.target)
					}
				}
			})

			if (!el.contains(e.target) && !clickedOnExcludedEl) {
				vnode.context[handler]()
			}
		}
		document.addEventListener('click', handleOutsideClick)
		document.addEventListener('touchstart', handleOutsideClick)
	},

	unbind() {
		document.removeEventListener('click', handleOutsideClick)
		document.removeEventListener('touchstart', handleOutsideClick)
	}
})
//Laddar hela applikationen
if (document.getElementById('app')) {
	new Vue({
		mixins: [mixin],
		store,
		router,
		// vuexLocal,
		i18n,
		render: h => h(App)
	}).$mount('#app')
}
//laddar in menyn
new Vue({
	mixins: [mixin],
	store,
	router,
	// vuexLocal,
	i18n,
	render: h => h(AppMenu)
}).$mount('.r360-container')
